import { useEffect } from "react";

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../../../components/ui/dialog.jsx";
import { useAuth } from "../../../context/AuthContext";
import { useData } from "../../../context/DataContext";

import TaskForm from "./TaskForm";

const TaskCreateDialog = ({ isOpen, onOpenChange, editingTaskId, newTask, setNewTask, onSubmit }) => {
  const { user } = useAuth();
  const { globalProjectId } = useData();

  useEffect(() => {
    if (isOpen && !editingTaskId) {
      setNewTask((prev) => ({
        ...prev,
        projectId: prev.projectId || (globalProjectId && globalProjectId !== "ALL" ? globalProjectId : ""),
        assignedTo: prev.assignedTo || user?.id || ""
      }));
    }
  }, [isOpen, editingTaskId, globalProjectId, user?.id, setNewTask]);

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] p-0 overflow-hidden flex flex-col">
        <div className="p-6 pb-0">
          <DialogHeader>
            <DialogTitle>{editingTaskId ? "Edit Task" : "Create New Task"}</DialogTitle>
            <DialogDescription>
              {editingTaskId ? "Modify the details of the existing task" : "Assign a new task to team members"}
            </DialogDescription>
          </DialogHeader>
        </div>
        <TaskForm newTask={newTask} setNewTask={setNewTask} onSubmit={onSubmit} editingTaskId={editingTaskId} />
      </DialogContent>
    </Dialog>
  );
};

export default TaskCreateDialog;
